import styles from "./accountlistcard.module.css";
import { Edit, MoreVertical, Plus, Trash2 } from "react-feather";
import { Dropdown } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import APIGraph from "./APIGraph";

const AccountListCard = ({ item, setShowDeleteModal, setSelectedData, setShowTuyaEditFormNew, setShowAddFormNew, setApartmentData }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<div className={`${styles.ProspectCard}`}>
        <div className={`${styles.ProspectCardUnder}`}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("device-iotaccount:update") > -1 || user["https://propertydek.com/permissions"].indexOf("device-iotaccount:delete") > -1) && (<Dropdown className={`${styles.ActionLeaseBUSec}`}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("device:create") > -1 && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setShowAddFormNew(true); setApartmentData({ 'property_id': item?.property_id, 'apt_id': item?.apt_id }) }}>
                            <Plus /> Add Devices
                        </Dropdown.Item>)}
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("device-iotaccount:update") > -1 && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setShowTuyaEditFormNew(true); setSelectedData(item); }}>
                            <Edit /> Edit
                        </Dropdown.Item>)}
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("device-iotaccount:delete") > -1 && (<Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setShowDeleteModal(true); setSelectedData(item); }}>
                            <Trash2 /> Delete
                        </Dropdown.Item>)}
                    </Dropdown.Menu>
                </Dropdown>)}

                {item?.type === 'TTLock' && <div className={`${styles.ProsIMGSec} ${styles.TTLock}`}>
                    <img src="/static/img/ttlock-logo.svg" className={`${styles.TuyaImg}`} alt="" />
                </div>}

                {item?.type === 'Tuya' && <div className={`${styles.ProsIMGSec}`}>
                    <img src="/static/img/tuya-logo.svg" className={`${styles.TuyaImg}`} alt="" />
                </div>}

                <div className={`${styles.HeadConSec}`}>
                    <p className={`${styles.ProsUserName}`}>
                        <span className={`${styles.UserName}`}>{item?.name}</span>
                    </p>
                    <p className={`${styles.ProsUserName} ${styles.Small}`}><span className={`${styles.HighListText}`}>{item?.no_of_device ? item?.no_of_device : 0}</span> Device Available</p>
                </div>
            </div>
            <div className={`${styles.ProspectCardBodySec}`}>
                <ul>
                    <li>
                        <p className={`${styles.Title}`}>Email:</p>
                        <p className={`${styles.Content}`}>{item?.email}</p>
                    </li>
                    {item?.type !== 'TTLock' && <li>
                        <p className={`${styles.Title}`}>Project ID:</p>
                        <p className={`${styles.Content}`}>{item?.project_id ? item?.project_id : ''}</p>
                    </li>}
                    {item?.type === 'TTLock' && <li>
                        <p className={`${styles.Title}`}>Client ID:</p>
                        <p className={`${styles.Content}`}>{item?.client_id ? item?.client_id : ''}</p>
                    </li>}
                    <li>
                        <p className={`${styles.Title}`}>Property:</p>
                        <p className={`${styles.Content} ${styles.Hover}`}>{item?.property_name ? item?.property_name : '-'}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}>Unit:</p>
                        <p className={`${styles.Content}`}>{item?.apt_name ? item?.apt_name : '-'}</p>
                    </li>
                </ul>
            </div>

            <APIGraph item={item} />

        </div>
    </div>)
}


export default AccountListCard;